import {
  Entity, PrimaryGeneratedColumn, Column, CreateDateColumn, UpdateDateColumn, JoinColumn, ManyToOne, DeleteDateColumn,
} from 'typeorm';
import { IsOptional, IsBoolean, IsInt } from 'class-validator';
import { Consulta } from './Consulta';
import { Usuario } from './Usuario';

@Entity({name: "pressoes_arteriais"})
export class PressaoArterial {
  @PrimaryGeneratedColumn()
  @IsOptional()
  @IsInt()
  id?: number;

  @Column()
  @IsInt()
  consulta_id: number;

  @Column()
  @IsInt()
  max: number;

  @Column()
  @IsInt()
  min: number;
  
  @Column()
  @IsOptional()
  observacoes: string | null;

  @CreateDateColumn()
  @IsOptional()
  created?: Date;

  @Column()
  @IsOptional()
  created_by?: number | null;

  @DeleteDateColumn({ name: 'deleted' })
  deleted?: Date

  @Column()
  @IsOptional()
  deleted_by?: number | null;

  // RELATIONS
  @ManyToOne(type => Consulta)
  @JoinColumn({ name: 'consulta_id' })
  consulta?: Consulta;

  @ManyToOne(type => Usuario, {
    eager: true
  })
  @JoinColumn({ name: 'created_by' })
  usuario_created_by?: Usuario;
}
